// extracted by mini-css-extract-plugin
export var badge = "_vk-4";
export var selected = "_vk-1";
export var selectedOverlay = "_vk-5";
export var thumbnailButton = "_vk-0";
export var thumbnailFallback = "_vk-3";
export var thumbnailImage = "_vk-2";